<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  :items='list'
  item-value='id'
  item-text='name'
)
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Партнер'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/partners', ['fetch']),
  computed: mapGetters('dictionary/partners', ['list'])
}
</script>
